import request from '../utils/request'

//登录
export function login(data) {
  return request({
    url: '/useraction/login',
    method: 'post',
    data
  })
}

export function reset(data) {
  return request({
    url: '/user/reset',
    method: 'post',
    data
  })
}

//更新api token
export function updateApiToken() {
  return request({
    url: '/me/apiToken',
    method: 'put',
  })
}


//用户列表(下拉选项)
export function getUserOptions(query) {
  return request({
    url: '/diagnosticdevices/getuserslist?Page=1&Size=100000000',
    method: 'get',
    params: query
  })
}

//用户组列表(下拉选项)
export function getUserGroupOptions(query) {
  return request({
    url: '/diagnosticdevices/getgrouplist?Page=1&Size=100000000',
    method: 'get',
    params: query
  })
}

//用户角色列表(下拉选项)
export function getUserRolesOptions(query) {
  return request({
    url: '/users/getuserroles',
    method: 'get',
    params: query
  })
}

//用户列表
export function getUsers(query) {
  return request({
    url: '/users/users',
    method: 'get',
    params: query
  })
}

//添加用户
export function addUser(data) {
  return request({
    url: '/users/users',
    method: 'post',
    data,
  })
}

//用户详情
export function getUser(id) {
  return request({
    url: '/users/user/'+id,
    method: 'get',
  })
}

//修改用户
export function editUser(data) {
  return request({
    url: '/users/users/'+data.userName,
    method: 'put',
    data
  })
}

//获取用户头像
export function getUserAvatar(id) {
  return request({
    url: '/users/showuserimage/'+id,
    method: 'get',
	type: 'download'
  })
}

//上传头像
export function uploadUserAvatar(data) {
  return request({
    url: '/users/uploadimage',
    method: 'post',
    data: data,
    type: 'formData'
  })
}

//删除用户
export function delUser(id) {
  return request({
    url: '/users/users/'+id,
    method: 'delete',
  })
}

//用户组列表
export function getGroups(query) {
  return request({
    url: '/group/groups',
    method: 'get',
    params: query
  })
}

//添加用户组
export function addGroup(data) {
  return request({
    url: '/group/groups',
    method: 'post',
    data
  })
}

//用户组详情
export function getGroup(id) {
  return request({
    url: '/group/group/'+id,
    method: 'get',
  })
}

//修改用户组
export function editGroup(data) {
  return request({
    url: '/group/groups/'+data.groupName,
    method: 'put',
    data
  })
}

//删除用户组
export function delGroup(id) {
  return request({
    url: '/group/groups/'+id,
    method: 'delete',
  })
}

